export default {
	'terms-and-conditions-privacy-policy': 'I confirm that I am at least 18 years of age and that I accept the <a href="/en-fi/terms" target="_blank" class="ui-link">Terms and Conditions</a> and <a href="/en-fi/privacy" target="_blank" class="ui-link">Privacy and Cookie Notice</a>.'
}